import { Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { Company } from '@qaroni-app/company/types/company';
import { ImagesConfig } from '@qaroni-core/config/app/images.config';

@Component({
  selector: 'qaroni-card-company',
  templateUrl: './card-company.component.html',
  styleUrls: ['./card-company.component.scss'],
  standalone: false,
})
export class CardCompanyComponent {
  readonly company = input<Company | null>(null);

  private router = inject(Router);

  public ImagesConfig = ImagesConfig;

  hasLogoUrl(company: Company): boolean {
    return company?.logoUrl ? true : false;
  }

  goToDetailsCompany(company: Company) {
    if (company?.companyId) {
      this.router.navigate([`/companies/${company.companyId}/details`]);
    }
  }
}
